// Two small number forms of the chrome. It is a leaf with no import.

/** A number rounded to one decimal, as text with no trailing zero: the
 *  coordinates of an inline SVG path (`12.5`, `3`). */
export function f1(v: number): string {
  return String(Math.round(v * 10) / 10);
}

/** A whole number of a decimal text, or 0 for a text that is no number.
 *  A text such as `12px` reads as 12, as `parseInt` reads it. */
export function toInt(v: string): number {
  const n = Number.parseInt(v, 10);
  return Number.isFinite(n) ? n : 0;
}
